import styled from 'styled-components/macro';

export const ProgressBarStyle = styled.div`
  width: 100%;
  position: relative;
  height: 8px;
  border-radius: 8px;
  background: rgba(241, 241, 241, 1);
  margin-top: 20px;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: ${({ $level }) => `${$level}%`};
    transition: 0.1s all ease-in-out;
    background: ${({ $level }) => ($level <= 50 ? 'var(--danger)' : 'var(--green)')};
    border-radius: 8px;
  }
`;
